// Google Analytics event tracking utility

declare global {
  interface Window {
    gtag: (
      command: 'config' | 'event',
      targetId: string,
      config?: {
        page_path?: string;
        event_category?: string;
        event_label?: string;
        value?: number;
        [key: string]: any;
      },
    ) => void;
  }
}

interface AnalyticsEvent {
  action: string;
  category?: string;
  label?: string;
  value?: number;
  [key: string]: any; // For custom parameters
}

export const trackGAEvent = (event: AnalyticsEvent): void => {
  if (typeof window !== 'undefined' && window.gtag) {
    const { action, category, label, value, ...customParams } = event;

    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
      ...customParams,
    });
  }
};
